export const EMPTY_DISPLAY_VALUE = "-";
export const DEBOUNCE_DELAY = 500;
export const ENROLLED_STATUS = "enrolled";
export const INVITE_PENDING_STATUS = "invite pending";
export const INVITE_EXPIRED_STATUS = "invite expired";
export const I18N_CACHE_KEY_PREFIX = "i18n_translation_";
export const AUTO_DISMISS_MS = 6000;
export const MAXIMUM_CHARACTER_LIMIT = 255;
export const USER_MANAGEMENT_BULK_ACTION_LIMIT = 5;
export const MAKE_ADMIN_SELECTION_LIMIT = 1;
export const UNICODE_NAME_REGEX = /^[\p{L}\p{M}'\u2019 -]+$/u;
export const EMAIL_PATTERN_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PHONE_NUMBER_PLACEHOLDER = "(555) 555 5555";

export const DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  month: "2-digit",
  day: "2-digit",
  year: "numeric",
};

/**
 * Allows Unicode letters (all scripts), digits, combining marks, whitespace,
 * and common address punctuation: hyphen, period, comma, apostrophe, slash, #, &
 * Blocks emojis, currency/math symbols, and other non-address characters.
 */
export const VALID_ADDRESS_CHARS_REGEX = /^[\p{L}\p{N}\p{M}\s\-.,'#&/]*$/u;

export const BLOCKED_EVENTS = [
  "pointerdown",
  "mousedown",
  "click",
  "touchstart",
  "keydown",
] as const;

export const API_DATA_STALE_TIME = 1 * 60 * 1000; // 1 minute

export const SORT_DIRECTION = {
  ASC: "asc",
  DESC: "desc",
} as const;

export const COLLATOR_USAGE = {
  SORT: "sort",
} as const;

export const UNICODE_FORM = {
  NFC: "NFC",
  NFD: "NFD",
} as const;

export const COLLATOR_SENSITIVITY = {
  BASE: "base",
} as const;

export const SEARCH_ACCENT_STRIP_REGEX = /[\u0300-\u036f]/g;

export const TOOLTIP_GAP = 8;
export const TOOLTIP_MAX_WIDTH = 300;
export const TOOLTIP_DELAY_DURATION = 200;
